/** @jsx jsx */
import React  from 'react';
import { css, jsx } from '@emotion/core';
import { productColor } from 'components/styles';
import { ButtonProps } from './BaseButton';
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';
import { useDispatch } from 'react-redux';
import { uiAppBarActions } from 'modules/ui/appBar';

const styles = {
  container: css`
    width: auto;
    height: auto;
    border-radius: 50%;
    span:not(:last-child){
      margin-bottom: 4px;
    }
    span
    {
      display: block;
      width: 22px;
      height: 2px;
      position: relative;
      
      background: ${productColor.primary};
      border-radius: 3px;
      z-index: 1;
      transform-origin: 4px 0px;
      transition: transform 0.3s cubic-bezier(0.77,0.2,0.05,1.0),
                  background 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
                  opacity 0.55s ease;
    }
    
    span:first-child
    {
      transform-origin: 0% 0%;
    }
    
    span:nth-last-child(2)
    {
      transform-origin: 0% 100%;
    }
  `,
  hoverCollapsed: css`
    :hover{
      cursor: pointer;
      span:first-child
      {
        opacity: 1;
        transform: rotate(-45deg) scale(0.5, 1) translate(-12px, 3px)
      }
      span:nth-child(3)
      {
        transform: rotate(45deg) scale(0.5, 1) translate(-12px, -1px);
      }
    }
  `,
  hoverNotCollapsed: css`
    :hover{
      cursor: pointer;
      span:first-child
      {
        opacity: 1;
        transform: rotate(45deg) scale(0.5,1) translate(18px,-11px);
      }
      span:nth-child(3)
      {
        transform: rotate(-45deg) scale(0.5,1) translate(13px,8px);
      }
    }
  `
}


type HamburgerButtonProps = Omit<ButtonProps, 'text'> & { text?: string };

const HamburgerButton: React.FC<HamburgerButtonProps> = ({
  customStyle
}) => {
  const collapsedSidebar = useSelector((state:Store) => state.ui.appBar.collapsedSidebar);
  
  // redux
  const dispatch = useDispatch();

 
  return(
    <div css={css([styles.container, collapsedSidebar ? styles.hoverNotCollapsed : styles.hoverCollapsed, customStyle])} onClick={() => dispatch(uiAppBarActions.toggle_collapsed_sidebar())}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  )
};

export default HamburgerButton;
